module.exports = __webpack_public_path__ + "static/media/java.69bd079a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/java.png
 ** module id = 1245
 ** module chunks = 0
 **/